declare global {
  interface Window {
    '@kodix/one': {
      pageLocator: {
        resolve(value: string): string | undefined
      }
    }
  }
}

export const getProjectName = (): string | undefined => {
  return window['@kodix/one']?.pageLocator?.resolve('ProjectName')
}
